import { render, staticRenderFns } from "./html-blocks.datatable.vue?vue&type=template&id=aad6f4dc&scoped=true&"
import script from "./html-blocks.datatable.vue?vue&type=script&lang=js&"
export * from "./html-blocks.datatable.vue?vue&type=script&lang=js&"
import style0 from "./html-blocks.datatable.vue?vue&type=style&index=0&id=aad6f4dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad6f4dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
